/**
 * Incidents as merchants read them: the words for their states, shared by the app, the POS and Hub's
 * emails and pushes (each passes its own t()).
 */

export const SEVERITIES = ["outage", "degraded", "maintenance", "notice"] as const
export const STATUSES = ["investigating", "identified", "monitoring", "resolved"] as const
export type Severity = (typeof SEVERITIES)[number]
export type Status = (typeof STATUSES)[number]

type T = (text: string) => string

export function statusLabel(t: T, status: Status): string {
  switch (status) {
    case "investigating":
      return t("Investigating")
    case "identified":
      return t("Cause found, being fixed")
    case "monitoring":
      return t("Fixed, monitoring")
    case "resolved":
      return t("Resolved")
  }
}

export function severityLabel(t: T, severity: Severity): string {
  switch (severity) {
    case "outage":
      return t("Not working")
    case "degraded":
      return t("Partly working")
    case "maintenance":
      return t("Maintenance")
    case "notice":
      return t("Notice")
  }
}
